// extracted by mini-css-extract-plugin
export default {"products":"qy-z","card":"ry-z","oosMessaging":"sy-z"};